import {Component, Input, OnInit} from '@angular/core';
import {IonNav} from '@ionic/angular';
import { ChargeAreaDetailsMarkerDto } from '../../domain/map/chargeAreaDetailsMarker';
import { FrontIziviaTranslateService } from '../../services/i18n/iziviaTranslate.service';
import { FrontMapMarkerHttpService } from '../../services/http/mapMarkerHttp.service';
import { SupportContact } from '../../domain/operator/frontEndConfig';
import { SupportContactBusinessService } from '../../services/business/supportContactBusiness.service';
import { SupportContactContext } from '../../domain/operator/frontEndConfig';
import { SupportContactRestrictionArea } from '../../domain/enum/supportContactRestrictionArea';
import {SupportContactListComponent} from './supportContactList/supportContactList.component';
import {SupportContactComponent} from './supportContact/supportContact.component';

@Component({
    selector: 'support-choice[thirdPartyId]',
    templateUrl: './supportChoice.component.html',
    styleUrls: ['./supportChoice.component.scss']
})
export class SupportChoiceComponent implements OnInit {

    @Input() thirdPartyId: string;

    @Input() chargeAreaMarkerDetail?: ChargeAreaDetailsMarkerDto;
    @Input() stationAlias?: string;
    @Input() restrictionArea?: SupportContactRestrictionArea;

    rootComponent: any;
    rootParams: {
        ionNav?: IonNav,
        canGoBack?: boolean,
        supportContact?: SupportContact,
        supportContacts?: SupportContact[],
        supportContactContext?: SupportContactContext,
        technicalSupportContact?: SupportContact,
        displayTechnicalSupportContactOrDefaultMessage?: boolean
    };

    constructor(private readonly translateService: FrontIziviaTranslateService,
        private readonly supportContactService: SupportContactBusinessService,
        private readonly mapMarkerService: FrontMapMarkerHttpService) {
    }

    ngOnInit(): void {
        if (!this.thirdPartyId) {
            throw new Error(`[${SupportChoiceComponent.name}] Input 'thirdPartyId' must be provided.`);
        }

        if (this.chargeAreaMarkerDetail) {
            // subject
            let mailSubject: string = '';
            if (this.chargeAreaMarkerDetail.brand) {
                mailSubject += `${this.chargeAreaMarkerDetail.brand} `;
            }

            mailSubject += `${this.chargeAreaMarkerDetail.name} `;

            if (this.chargeAreaMarkerDetail.supervisedId) {
                mailSubject += `| ${this.chargeAreaMarkerDetail.supervisedId}`;
            }

            if (this.stationAlias) {
                mailSubject += `| ${this.stationAlias}`;
            }

            // body
            const mailBody: string = this.translateService.translate('support.mailTo.body', {
                chargeArea: mailSubject
            });

            const context: SupportContactContext = {
                mailSubject: mailSubject,
                mailBody: mailBody
            };

            this.supportContactService.findSupportContacts(this.thirdPartyId, this.restrictionArea).subscribe(supportContacts => {
                this.mapMarkerService.fetchTechnicalSupportContact(this.chargeAreaMarkerDetail.id)
                    .subscribe(technicalSupportContact => {
                        this.createRootComponentAndParams(supportContacts, context, technicalSupportContact);
                    }, () => {
                        this.createRootComponentAndParams(supportContacts, context);
                    });
            });
        } else {
            this.supportContactService.findSupportContacts(this.thirdPartyId, this.restrictionArea).subscribe(supportContacts => {
                this.createRootComponentAndParams(supportContacts);
            });
        }
    }

    private createRootComponentAndParams(supportContacts: SupportContact[],
        supportContactContext?: SupportContactContext,
        technicalSupportContact?: SupportContact
    ) {
        // If we came from chargeAreaMarkerDetail (context set) we want to display a technical support contact
        // Even if he is null we want to display a default message (without having nested contact data)
        // We can always use SupportContactListComponent for this case
        // SupportContactComponent should be used for some support case from account only
        const displayTechnicalSupportContactOrDefaultMessage = !!supportContactContext;
        if (supportContacts?.length > 0 || displayTechnicalSupportContactOrDefaultMessage) {
            if (supportContacts.length === 1 && !displayTechnicalSupportContactOrDefaultMessage) {
                this.rootComponent = SupportContactComponent;
                this.rootParams = {
                    supportContact: supportContacts[0],
                    supportContactContext: supportContactContext
                };
            } else {
                this.rootComponent = SupportContactListComponent;
                this.rootParams = {
                    supportContacts,
                    supportContactContext: supportContactContext,
                    technicalSupportContact,
                    displayTechnicalSupportContactOrDefaultMessage
                };
            }
        }
    }
}
